import { API_CALL, RESET_GIFTSTORE, RESET_GIFTSTORE_ERRORS } from '../constants/actionTypes';
import { GIFTSTORE_PRODUCTS, GIFTSTORE_PURCHASES, GIFTSTORE_REDEEM } from '../constants/apiTypes';
import { getProducts, getPurchases, purchaseProduct } from '../api/giftstore';

export function fetchProducts() {
  return {
    type: API_CALL,
    api: GIFTSTORE_PRODUCTS,
    request: getProducts()
  };
}

export function fetchPurchases(query = {}) {
  return {
    type: API_CALL,
    api: GIFTSTORE_PURCHASES,
    request: getPurchases(query)
  };
}

export function redeemProduct(id) {
  return dispatch => {
    dispatch({
      type: API_CALL,
      api: GIFTSTORE_REDEEM,
      request: purchaseProduct(id)
    });
  };
}

export function resetErrors() {
  return {
    type: RESET_GIFTSTORE_ERRORS
  };
}

export function resetState() {
  return {
    type: RESET_GIFTSTORE
  };
}
